export const ANALYTICS_FILTER_PREFIX = 'analytics_filters.'

export const clearAnalyticsFilters = () => {
  try {
    Object.keys(sessionStorage)
      .filter(key => key.startsWith(ANALYTICS_FILTER_PREFIX))
      .forEach(key => sessionStorage.removeItem(key))
  } catch {
    /* ignore */
  }
}
